import { GroundTruthDataListView, ReviewStatus } from "src/store/modelLifeCycleGroundTruthSlice";
import { Model } from "src/store/modelManagementSlice";
import { isAssignedBasedReview } from "src/components/shared/groundTruth/reviewTable/helpers";

export const getGroundTruthDataListViewStatus = (
  groundTruthDataListView: GroundTruthDataListView,
  selectedModel: Model,
  alias: string,
) => {
  // check if the alias been assigned review
  if (groundTruthDataListView.pendingReviewers?.includes(alias)) {
    if (groundTruthDataListView.reviewContributors?.includes(alias)) {
      return "Pending re-review";
    } else if (
      groundTruthDataListView.adminReviewers?.includes(alias) &&
      groundTruthDataListView.pendingReviewers?.includes(alias) &&
      groundTruthDataListView.reviewContributors &&
      groundTruthDataListView.reviewContributors?.length >= 1
    ) {
      return "Pending validation";
    } else {
      return "Pending review";
    }
    // if reviewer not being assigned, fall into assignment-based review logic
  } else if (isAssignedBasedReview(selectedModel)) {
    if (groundTruthDataListView.reviewContributors?.includes(alias)) {
      return "Reviewed";
    } else {
      return "Pending review";
    }
    // default share review logic
  } else {
    return groundTruthDataListView.status === ReviewStatus.REVIEWED ? "Reviewed" : "Pending review";
  }
};

export const getGroundTruthDataListViewReviewer = (
  groundTruthDataListView: GroundTruthDataListView,
  alias: string,
) => {
  return groundTruthDataListView.reviewContributors?.includes(alias)
    ? alias
    : groundTruthDataListView.reviewer;
};
